import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useExperiences } from 'core/contexts/experience';
import { useExperiences as useExperiencesV2 } from 'core/contexts/experienceV2';
import { Box, Grid2 } from '@mui/material';
import { CircularIndeterminate, CalendarPage as FullCalendar } from '@utriper/core-ui';
import { useCalendarPage } from './hook';
import { useStyles } from './styles';
import Layout from 'components/Layout';
import EventContent from './components/EventContent';
import ScheduleForm from './components/ScheduleForm';
import FutureEventsModal from './components/FutureEventsModal';

const ExperienceCalendarPage = () => {
    const history = useHistory();
    const { id } = useParams();
    const experienceId = parseInt(id);
    const { loading: loadingExperience, getExperienceById, experience } = useExperiencesV2();
    const { loading, experienceSchedule } = useExperiences();
    const classes = useStyles();
    const [experienceDetailId, setExperienceDetailId] = useState(null);
    const [experienceDetailOptions, setExperienceDetailOptions] = useState(null);

    const {
        onEventClick,
        calendar: { calendarRange, setCalendarRange, getEvents, onSelect, onClose, onSubmit, onUpdate, onDelete, start, end, timezone, setTimezone },
        popOver: { show, position, clickedEvent, isEdit },
        futureEventsModal: { openUpdate, openDelete, eventToUpdate },
    } = useCalendarPage();

    useEffect(() => {
        getExperienceById(experienceId, history);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [experienceId]);

    useEffect(() => {
        const loadExperienceDetails = () => {
            if (experience?.id && Array.isArray(experience?.expDetail) && experience?.expDetail?.length > 0) {
                const experienceDetails = experience.expDetail.map((expDetail) => ({
                    ...expDetail,
                    name: expDetail?.description1,
                }));

                setExperienceDetailId(experienceDetails[0]?.id);
                setExperienceDetailOptions([...experienceDetails]);
            }
        };

        loadExperienceDetails();
    }, [experience]);

    useEffect(() => {
        getEvents(calendarRange, experienceDetailId, experience?.id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [experience, calendarRange, experienceDetailId]);

    const renderEventContent = (eventInfo) => {
        return <EventContent eventInfo={eventInfo} />;
    };

    return (
        <Layout>
            {loadingExperience ? (
                <CircularIndeterminate centered />
            ) : (
                <Grid2 container className={classes.gridContainer}>
                    {loading && (
                        <Box className={classes.loaderContainer}>
                            <CircularIndeterminate centered />
                        </Box>
                    )}

                    <FullCalendar schedules={experienceSchedule} renderEventContent={renderEventContent} setCalendarRange={setCalendarRange} onSelect={onSelect} tz={timezone} setTz={setTimezone} experienceDetail={experienceDetailId} setExperienceDetail={setExperienceDetailId} experienceDetailOptions={experienceDetailOptions} title={experience?.name} onEventClick={onEventClick} showSelectOptions>
                        <ScheduleForm
                            data={{
                                experienceId: experience?.id,
                                experienceDetailId,
                                initialValues: { ...clickedEvent, experienceDetailId, experienceId: experience?.id },
                                start,
                                end,
                                timezone,
                                loading,
                            }}
                            actions={{
                                onClose,
                                onSubmit,
                            }}
                            config={{
                                open: show,
                                isEdit,
                                position,
                                calendarTimezone: timezone,
                            }}
                        />
                    </FullCalendar>

                    {(openUpdate || openDelete) && eventToUpdate && (
                        <FutureEventsModal
                            open={openUpdate || openDelete}
                            event={{ ...eventToUpdate }}
                            isDelete={openDelete}
                            onSubmit={(values) => {
                                if (openUpdate) {
                                    return onUpdate(values);
                                }
                                if (openDelete) {
                                    return onDelete(values);
                                }
                            }}
                            onClose={onClose}
                            loading={loading}
                        />
                    )}
                </Grid2>
            )}
        </Layout>
    );
};

export default ExperienceCalendarPage;
